import Vue from 'vue'

//获取钉钉应用ID-用于扫码登录
/**
 *
 * @param data
 * @returns {*}
 */
export function getDingtalkAppId(data) {
  return Vue.axios({
    url: '/api/common/getDingtalkAppId', method: 'get', params: {...data}
  })
}

/**
 * 钉钉应用信息：客户端信息
 * @param data
 * @returns {*}
 */
export function getDingTalkClient(data) {
  return Vue.axios({
    url: '/api/common/getDingTalkClient', method: 'get', params: {...data}
  })
}

/**
 * 飞书应用配置信息（用途：飞书登录，不含 App Secret）
 * @param data
 * @returns {*}
 */
export function getFeishuApp(data) {
  return Vue.axios({
    url: '/api/common/getFeishuApp', method: 'get', params: {...data}
  })
}

//根据用户UnionId获取用户钉钉信息
export function getUserInfoByUnionId(data) {
  return Vue.axios({
    url: '/api/common/getUserInfoByUnionId', method: 'post', data: {...data}
  })
}

//钉钉扫码后，确认注册
export function dingTalkRegister(data) {
  return Vue.axios({
    url: '/api/common/dingTalkRegister', method: 'post', data: {...data}
  })
}

/**
 * 获取websocket服务的配置信息
 * @param data
 * @returns {Promise<*>}
 */
export async function websocketConfig(data) {
  const response = await Vue.axios({
    url: '/api/websocketConfig', method: 'post', data
  })

  const {model: {info}} = response
  if (info && info.host) {
    let host = info.host
    const protocol = window.location.protocol;

    // 判断协议类型
    if (protocol === 'https:') {
      host = host.replace("ws:", "wss:")
    } else if (protocol === 'http:') {
      host = host.replace("wss:", "ws:")
    }
    response.model.info.host = host
  }
  return response
}

/**
 * 获取分页接口
 * @param api
 * @param params
 * @returns {Promise<*>}
 */
export async function getPageCommon(api, params) {
  if (typeof api === 'function') {
    return await api(params)
  }

  return await Vue.axios({
    url: `${api}`, method: 'get', params
  })
}
